import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const TrialExpired = () => {
    const { t } = useTranslation();
    useEffect(() => {
        // Signal to index.html that app is loaded and we're showing trial expired screen
        // This prevents maintenance mode from triggering
        if (window.appLoadedResolve) {
            window.appLoadedResolve();
        }
        // Also set a flag that trial expired is showing
        window.trialExpiredShowing = true;
        
        return () => {
            window.trialExpiredShowing = false;
        };
    }, []);
    const handlePurchaseClick = () => {
        // Open IzzyGo AppSource listing for purchase
        window.open('https://appsource.microsoft.com/en-us/marketplace/checkout/appdate1586417772427.izzygo?tab=Overview', '_blank');
    };

    // Match the exact maintenance mode UI from index.html
    return (
        <div style={{ 
            display: 'flex', 
            position: 'fixed', 
            top: 0, 
            left: 0, 
            width: '100%', 
            height: '100%', 
            background: 'rgba(255,255,255,0.95)', 
            zIndex: 9999, 
            justifyContent: 'center', 
            alignItems: 'center', 
            flexDirection: 'column'
        }}>
            <div style={{ textAlign: 'center', padding: '20px' }}>
                {/* Clock/Warning Icon - similar to maintenance mode */}
                <div style={{ fontSize: '48px', marginBottom: '24px' }}>
                    ⏰
                </div>
                
                {/* Title - matching maintenance mode style */}
                <h2 style={{ 
                    color: '#323130', 
                    fontSize: '24px', 
                    fontWeight: 600, 
                    margin: '0 0 16px'
                }}>
                    {t('trialExpired.title')}
                </h2>
                
                {/* Message */}
                <p style={{ 
                    color: '#605e5c', 
                    fontSize: '14px', 
                    lineHeight: '20px', 
                    margin: '0 0 24px',
                    maxWidth: '400px'
                }}>
                    {t('trialExpired.message')}
                    <br />
                    {t('trialExpired.contactAdmin')}
                </p>
                
                {/* Purchase Button */}
                <button 
                    onClick={handlePurchaseClick}
                    style={{
                        backgroundColor: '#0078d4',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        padding: '10px 20px',
                        fontSize: '14px',
                        fontWeight: 600,
                        cursor: 'pointer',
                        marginBottom: '12px'
                    }}
                    onMouseOver={(e) => e.target.style.backgroundColor = '#106ebe'}
                    onMouseOut={(e) => e.target.style.backgroundColor = '#0078d4'}
                >
                    {t('common.purchaseLicenses')}
                </button>
                
                {/* Help text */}
                <div style={{ 
                    fontSize: '12px', 
                    color: '#8a8886',
                    marginTop: '8px'
                }}>
                    {t('trialExpired.needHelp')}
                </div>
            </div>
        </div>
    );
};

export default TrialExpired;